import React, { useEffect } from 'react';
import { Grid, TextField, Typography, Paper, MenuItem, Divider } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

/* =======================
    STEP 1 — Datos Generales y Objetivo
   ======================= */
function DatosGenerales({ state, onChange, onError, solicitud, profesionalesOpciones = [] }) {
    const safeValue = (field) => (state?.[field]?.valor || '');
    const safeError = (field) => (state?.[field]?.error || '');
    const theme = useTheme();


    useEffect(() => {
        if (solicitud?.usuario_registro) {

            const usuario = solicitud.usuario_registro;

            const nombreCompleto = `
                ${usuario.primer_nombre || ''} 
                ${usuario.segundo_nombre || ''} 
                ${usuario.primer_apellido || ''} 
                ${usuario.segundo_apellido || ''}
            `.replace(/\s+/g, ' ').trim();

            onChange({
                target: {
                    name: 'nombre_completo',
                    value: nombreCompleto
                }
            });

            onChange({
                target: {
                    name: 'documento_identidad',
                    value: usuario.identificacion || ''
                }
            });

            onChange({
                target: {
                    name: 'numero_contacto',
                    value: usuario.celular || usuario.telefono || ''
                }
            });
        }

    }, [solicitud]);

    return (
        <Grid container spacing={3}>

            <Grid item xs={12}>
                <Paper elevation={0} style={{ padding: 15, backgroundColor: '#f9f9f9', borderLeft: `4px solid ${theme.palette.primary.main}`}}>
                    <Typography variant="subtitle2" gutterBottom>
                        OBJETIVO DEL ENCUENTRO PSICOEDUCATIVO
                    </Typography>
                    <Typography variant="caption" style={{ textAlign: 'justify', display: 'block' }}>
                        Este espacio tiene como propósito brindar información clara y pertinente sobre las diversas tipologías de violencias basadas en género, el funcionamiento de la ruta de atención institucional y otros temas relacionados desde una perspectiva de cultura de equidad. Asimismo, busca promover la comprensión de los derechos, responsabilidades y posibles consecuencias derivadas de estas situaciones, con el fin de asegurar un abordaje ético, preventivo y restaurativo que fomente el respeto y la protección de todas las personas involucradas.
                    </Typography>
                </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    label="Nombre de la persona atendida"
                    name="nombre_completo"
                    value={safeValue('nombre_completo')}
                    onChange={onChange}
                    error={!!safeError('nombre_completo')}
                    helperText={safeError('nombre_completo')}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    label="Documento de identidad"
                    name="documento_identidad"
                    value={safeValue('documento_identidad')}
                    onChange={onChange}
                    error={!!safeError('documento_identidad')}
                    helperText={safeError('documento_identidad')}
                />
            </Grid>

           <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label="lugar de expedición del documento"
                    name="lugar_expedicion"
                    value={safeValue('lugar_expedicion')}
                    onChange={onChange}
                    error={!!safeError('lugar_expedicion')}
                    helperText={safeError('lugar_expedicion')}
                />
            </Grid>


            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label="Contacto (Teléfono o Celular)"
                    name="numero_contacto"
                    value={safeValue('numero_contacto')}
                    onChange={onChange}
                    error={!!safeError('numero_contacto')}
                    helperText={safeError('numero_contacto')}
                />
            </Grid>

            <Grid item xs={12} md={3}>
                <TextField
                    fullWidth
                    type="date"
                    label="Fecha de la intervención"
                    name="fecha_intervencion"
                    InputLabelProps={{ shrink: true }}
                    value={safeValue('fecha_intervencion')}
                    error={!!safeError('fecha_intervencion')}
                    helperText={safeError('fecha_intervencion')}
                    onChange={onChange}
                />
            </Grid>

            <Grid item xs={12} md={3}>
                <TextField
                    select
                    fullWidth
                    label="Rol en el caso"
                    name="rol_caso"
                    value={safeValue('rol_caso')}
                    error={!!safeError('rol_caso')}
                    helperText={safeError('rol_caso')}
                    onChange={onChange}
                >
                    <MenuItem value="Posible víctima">Posible víctima</MenuItem>
                    <MenuItem value="Posible ofensor">Posible ofensor</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    required
                    select
                    label="Profesional que brinda la psicoeducación"
                    name="responsable_atencion"
                    value={safeValue('responsable_atencion')}
                    onChange={onChange}
                    error={!!safeError('responsable_atencion')}
                    helperText={safeError('responsable_atencion') || "Selecciona el profesional"}
                >
                    {(Array.isArray(profesionalesOpciones) && profesionalesOpciones.length > 0) ? (
                        profesionalesOpciones.map((prof) => (
                            <MenuItem key={prof.value} value={prof.label}>
                                {prof.label}
                            </MenuItem>
                        ))
                    ) : (
                        <MenuItem disabled>No hay profesionales disponibles</MenuItem>
                    )}
                </TextField>
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label="Cargo"
                    name="cargo_profesional"
                    value={safeValue('cargo_profesional')}
                    error={!!safeError('cargo_profesional')}
                    helperText={safeError('cargo_profesional')}
                    onChange={onChange}
                />
            </Grid>

            <Grid item xs={12}>
                <Paper elevation={0} style={{ padding: 15, backgroundColor: '#f9f9f9', borderLeft: `4px solid ${theme.palette.primary.main}`}}>
                    <Typography variant="subtitle2" gutterBottom>
                        Nota Importante
                    </Typography>
                    <Typography variant="caption" style={{ textAlign: 'justify', display: 'block' }}>
                        Este documento hace parte del proceso psicoeducativo dentro del protocolo de atención institucional y será tratado bajo criterios de confidencialidad, protección de datos y respeto a los derechos humanos de todas las partes involucradas.
                    </Typography>
                </Paper>
            </Grid>
        </Grid>
    );
}

/* =======================
    STEP 2 — Contenido y Compromisos
   ======================= */
function ContenidoCompromisos({ state, onChange }) {
    const safeValue = (field) => (state?.[field]?.valor || '');
    const safeError = (field) => (state?.[field]?.error || '');

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    variant="outlined"
                    label="Tema abordado en la Psicoeducación"
                    name="tema_abordado"
                    placeholder="Ej: Tipologías de VBG, Consentimiento, Masculinidades, etc."
                    value={safeValue('tema_abordado')}
                    error={!!safeError('tema_abordado')}
                    helperText={safeError('tema_abordado')}
                    onChange={onChange}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    variant="outlined"
                    label="Compromisos asumidos"
                    name="compromisos_asumidos"
                    value={safeValue('compromisos_asumidos')}
                    error={!!safeError('compromisos_asumidos')}
                    helperText={safeError('compromisos_asumidos')}
                    onChange={onChange}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label="Observaciones adicionales"
                    name="observaciones_adicionales"
                    value={safeValue('observaciones_adicionales')}
                    error={!!safeError('observaciones_adicionales')}
                    onChange={onChange}
                    helperText={safeError('observaciones_adicionales') || "(Espacio libre para anotar detalles relevantes del proceso o seguimiento requerido)"}
                />
            </Grid>


        </Grid>
    );
}

export const FormatoPsicoeducacion008Steps = [
    {
        label: 'Información General',
        render: (props) => <DatosGenerales {...props} />
    },
    {
        label: 'Temas y Compromisos',
        render: (props) => <ContenidoCompromisos {...props} />
    }
];